import React from "react";
import PropTypes from "prop-types";
import { Button, DialogContent, Grid, TextField, Typography } from "@material-ui/core";
import { useDialog } from "../Dialogs/DialogProvider";
import { Supergroup } from "../../store/articles/models/Supergroup";

function AddSupergroupDialog(props) {
  const [, closeDialog] = useDialog();
  const [supergroup, setSupergroup] = React.useState(
    props.supergroup ?? new Supergroup(null, "", "", 0, true, null, null, null)
  );

  return (
    <>
      <DialogContent>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            props.onSubmit(e, supergroup);
            closeDialog();
          }}
        >
          <Typography>{props.supergroup ? "Update" : "New"} Supergroup</Typography>
          <Grid container>
            <Grid container item>
              <Grid item xs={12}>
                <TextField
                  label={"Supergroup name"}
                  name={"tag"}
                  value={supergroup.tag}
                  onChange={(e) => {
                    let newObject = Object.assign(new Supergroup(), supergroup);
                    newObject.tag = e.target.value;
                    newObject.name = e.target.value;
                    setSupergroup(newObject);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container item>
              <Grid item>
                <Button
                  onClick={() => {
                    closeDialog();
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button type={"submit"}>Ok</Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </>
  );
}

AddSupergroupDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default AddSupergroupDialog;
